import React, { useRef, useEffect } from 'react';
import { Link } from 'react-router';
import './EliteUpsellPrompt.css';

interface EliteUpsellPromptProps {
  onClose: () => void;
}

export const EliteUpsellPrompt: React.FC<EliteUpsellPromptProps> = ({ onClose }) => {
  const promptRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const handleClickOutside = (e: MouseEvent) => {
      if (promptRef.current && !promptRef.current.contains(e.target as Node)) {
        onClose();
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, [onClose]);

  return (
    <div className="elite-upsell-prompt" ref={promptRef}>
      <p className="elite-upsell-prompt__text">
        Upload custom emoji with TradeMagic Elite. Your emoji become available to the entire community!
      </p>
      <div className="elite-upsell-prompt__actions">
        <Link to="/elite?source=custom-emoji" className="elite-upsell-prompt__link" onClick={onClose}>
          Learn More
        </Link>
        <button className="elite-upsell-prompt__dismiss" onClick={onClose} type="button">
          Dismiss
        </button>
      </div>
    </div>
  );
};
